export const INTERACTIVE_TOOLTIP_MOUSEOUT_DELAY = 200;
